import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Screen\CreateScreenConfigController::__invoke
* @see app/Http/Controllers/Screen/CreateScreenConfigController.php
* @route '/api/screen-config'
*/
const CreateScreenConfigController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateScreenConfigController.url(options),
    method: 'post',
})

CreateScreenConfigController.definition = {
    methods: ["post"],
    url: '/api/screen-config',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Screen\CreateScreenConfigController::__invoke
* @see app/Http/Controllers/Screen/CreateScreenConfigController.php
* @route '/api/screen-config'
*/
CreateScreenConfigController.url = (options?: RouteQueryOptions) => {
    return CreateScreenConfigController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Screen\CreateScreenConfigController::__invoke
* @see app/Http/Controllers/Screen/CreateScreenConfigController.php
* @route '/api/screen-config'
*/
CreateScreenConfigController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateScreenConfigController.url(options),
    method: 'post',
})

export default CreateScreenConfigController